import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { LocalizationService } from '@services/localization.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@pipes/translate.pipe';
import { LeagueFilterComponent } from './league.filter.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DataHelper } from '@helpers/data.helper';
import { UserHelper } from '@helpers/user.helper';
import { sportsSvgList } from '@app/constants/svgUrl.constant';

@Component({
  selector: 'story-slider',
  templateUrl: '../sharedTemplates/story.slider.component.html',
})
export class StorySliderComponent {
  public sportsSvgList = sportsSvgList;
  listArray = [];
  translator = new TranslatePipe(this._LocalizationService);
  _SelectedItem = this.translator.transform('Soccer', null);
  SelectedSportId = 1;
  @Output() clickedItem = new EventEmitter<any>();
  @Input()
  slideShowTime = 2;
  filterItemCount;

  @Input()
  set filterItem(e) {
    if (e) {
      this.filterItemCount = e.length;
    }
  }

  @Input()
  set slideShow(e) {
    if (e) {
      this.slideShowSetter();
    }
  }

  @Input()
  elementData;

  @Input()
  set data(e) {
    if (e && e != undefined && e.length > 0) {
      this.listArray = [];
      if (this.elementData && this.elementData != undefined && this.elementData.length > 0) {
        e.forEach((x, index1) => {
          this.elementData.forEach((y, index2) => {
            if (y.SportName == x.key1) {
              const _data = {
                imageUrl: y.imageUrl,
                pngUrl: y.pngUrl,
                sportName: x.key2,
                count: x.count,
                sportId: x.sportId,
                selected: this.SelectedSportId == x.sportId ? true : false,
                sportNameOrginal: y.SportName,
              };
              this.listArray.push(_data);
              if (_data.selected == true) {
                this._DataHelper.selectedStoryItem = _data;
                this.SelectedSportId = x.sportId;
                this._SelectedItem = x.key2;
              }

              // ESKİ => 13.04.2022 de değiştirildi. SONRA SİL
              // if (index1 == 0 && this.SelectedSportId == 1){
              //   const _data = {
              //     'imageUrl': y.imageUrl,
              //     'pngUrl': y.pngUrl,
              //     'sportName': x.key2,
              //     'count': x.count,
              //     'sportId': x.sportId,
              //     'selected': true,
              //     'sportNameOrginal': y.SportName
              //   };
              //   this.listArray.push(_data);
              //   if(_data.selected==true){
              //     this._DataHelper.selectedStoryItem=_data;
              //
              //   }
              //
              //   thiss.SelectedSportId = x.sportId;
              //   thiss._SelectedItem = x.key2;
              //
              // }else{
              //   const _data = {
              //     'imageUrl': y.imageUrl,
              //     'pngUrl': y.pngUrl,
              //     'sportName': x.key2,
              //     'count': x.count,
              //     'sportId': x.sportId,
              //     // 'selected': thiss._SelectedItem === x.key2 ? true : false,
              //
              //     'selected': thiss.SelectedSportId == x.sportId ? true : false,
              //     'sportNameOrginal': y.SportName
              //   };
              //   this.listArray.push(_data);
              // }
            }
          });
        });

        this.listArray.splice(this.listArray.length, 0, {
          imageUrl: 'all.svg',
          pngUrl: 'all.svg',
          sportName: this.translator.transform('all', null),
          selected: false,
          sportId: -1,
          sportNameOrginal: 'all',
        });
        // //console.log('this.listArray',this.listArray)

        this.clickedItem.emit({ sportName: this._SelectedItem, sportId: this.SelectedSportId });
      } else {
        this.listArray = e;
      }
    }
  }

  constructor(
    private _UiHelper: UiHelper,
    public _LZ: LocalizationService,
    public _Router: Router,
    private _ActivatedRoute: ActivatedRoute,
    private _LocalizationService: LocalizationService,
    private _BottomSheet: MatBottomSheet,
    public _DataHelper: DataHelper,
    public _UserHelper: UserHelper
  ) {
    if (this._DataHelper.selectedStoryItem != undefined) {
      // 03-02-2022 de kapatıldı. Ice Hockey ve Table Tennis te  maç detayına gidip tekrar Live a dönünce Seçilen Spor bozuluyordu.
      // Default olarak Tennis e veya Soccer a gidiyordu
      // this._SelectedItem=this.translator.transform(`${this._DataHelper.selectedStoryItem.sportNameOrginal}`, null);

      if (this._DataHelper.selectedStoryItem != undefined) {
        this._SelectedItem = this._DataHelper.selectedStoryItem.sportName;
        this.SelectedSportId = this._DataHelper.selectedStoryItem.sportId;
      }
    }
  }

  selectStoryItem(e) {
    localStorage.setItem('league-filter-data', JSON.stringify([]));

    this.listArray = this.listArray.map(x => {
      if (x != undefined && x.sportName == e) {
        x.selected = true;
        this.SelectedSportId = x.sportId;

        this._SelectedItem = x.sportName;
      } else {
        x.selected = false;
      }
      return x;
    });
    // this.clickedItem.emit(e);
    this.clickedItem.emit({ sportName: e, sportId: this.SelectedSportId });
    this._DataHelper.setFavoritesButtonStatus(false);
  }

  selectStoryItemForB3000(e) {
    this._DataHelper.selectedStoryItem = e;
    //Yapı düzgün çalışsın diye manuel setlendi comboOdd lar değişince kurgu değişecek
    this._DataHelper.comboSelectedOdd = { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] };

    // League Filter Clean ( Local Storage )
    localStorage.setItem('league-filter-data', JSON.stringify([]));

    // //console.log('selectStoryItem',e);
    this.listArray = this.listArray.map(x => {
      if (x.sportName == e.sportName) {
        x.selected = true;
        this.SelectedSportId = x.sportId;
        // console.log('--SelectedSportId--',x.sportId)
        //console.log('--sportID--',this.SelectedSportId)
        this._SelectedItem = x.sportName;
      } else {
        x.selected = false;
      }
      return x;
    });
    // this.clickedItem.emit(e);
    this.clickedItem.emit({ sportName: e.sportName, sportId: this.SelectedSportId });
    this._DataHelper.setFavoritesButtonStatus(false);
  }

  slideShowSetter() {
    setInterval(() => {
      /*
          if (this.selectedListItem != this.listArraySize) {
            this.changeSlider(this.selectedListItem + 1);
          } else {
            this.changeSlider(1);
          }
  */
    }, this.slideShowTime * 1000);
  }

  openFilter() {
    this._BottomSheet.open(LeagueFilterComponent);
  }

  liveFavEnabled() {
    this._DataHelper.setFavoritesButtonStatus(!this._DataHelper.liveFavoriteButtonStatus);
    const e = {
      count: 5,
      imageUrl: 'all.svg',
      pngUrl: 'all.svg',
      sportName: this.translator.transform('all', null),
      selected: false,
      sportId: -1,
      sportNameOrginal: 'all',
    };
    this._DataHelper.selectedStoryItem = e;
    //Yapı düzgün çalışsın diye manuel setlendi comboOdd lar değişince kurgu değişecek
    this._DataHelper.comboSelectedOdd = { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] };

    // League Filter Clean ( Local Storage )
    localStorage.setItem('league-filter-data', JSON.stringify([]));

    // //console.log('selectStoryItem',e);
    this.listArray = this.listArray.map(x => {
      if (x.sportName == e.sportName) {
        x.selected = true;
        this.SelectedSportId = x.sportId;
        // console.log('--SelectedSportId--',x.sportId)
        //console.log('--sportID--',this.SelectedSportId)
        this._SelectedItem = x.sportName;
      } else {
        x.selected = false;
      }

      return x;
    });
    // this.clickedItem.emit(e);
    this.clickedItem.emit({ sportName: this._SelectedItem, sportId: this.SelectedSportId });

    // this.clickedItem.emit({ sportName: e.sportName, sportId: this.SelectedSportId });
  }
}
